import React from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-portal'
import cx from 'classnames'

import Overlay from 'components/_new/layout/Overlay/Overlay'

import s from './FixedSidebar.scss'


const FixedSidebar = ({ children, className, isOpened, position, withOverlay, onOverlayClick }) => {
  const sideMenuClassName = cx(s.sideMenu, className, {
    [s[position]]: position,
    [s.opened]: isOpened,
  })

  return (
    <Portal>
      <div>
        {
          withOverlay && isOpened && (
            <Overlay onClick={onOverlayClick} />
          )
        }
        <div className={sideMenuClassName}>
          <div className={s.content}>
            {children}
          </div>
        </div>
      </div>
    </Portal>
  )
}

FixedSidebar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpened: PropTypes.bool.isRequired,
  position: PropTypes.oneOf([ 'left', 'right' ]),
  withOverlay: PropTypes.bool,
  onOverlayClick: PropTypes.func,
}

FixedSidebar.defaultProps = {
  position: 'left',
  withOverlay: false,
  isOpened: false,
}


export default FixedSidebar
